import { LocaleType as DesignSystemLocaleType } from "@/components/organisms/LocaleSelectorModal/LocaleSelectorModal.types";

import { Locale, LocaleDataMap } from "./i18n.types";

const LOCALES_NAMESPACES = {
  EN_US: "en-US",
  FR_FR: "fr-FR",
  DE_DE: "de-DE",
  ES_ES: "es-ES",
  EN_AU: "en-AU",
  EN_CA: "en-CA",
  EN_GB: "en-GB",
} as const;

const ACTIVE_LOCALES: LocaleDataMap = {
  "de-DE": {
    urlPrefix: "de",
    urlPrefixWithSlash: "/de",
    zendeskUrlLocale: "en-us",
    region: "Europe",
    language: "Deutsch",
    country: "Deutschland",
    googleLocale: "de",
    locale: "de-DE",
  },
  "en-GB": {
    urlPrefix: "uk",
    urlPrefixWithSlash: "/uk",
    zendeskUrlLocale: "en-us",
    region: "Europe",
    language: "English",
    country: "United Kingdom",
    googleLocale: "en-GB",
    locale: "en-GB",
  },
  "en-US": {
    urlPrefix: "",
    urlPrefixWithSlash: "",
    zendeskUrlLocale: "en-us",
    region: "Les Amériques",
    language: "English",
    country: "United States",
    googleLocale: "en",
    locale: "en-US",
  },
  "en-CA": {
    urlPrefix: "ca",
    urlPrefixWithSlash: "/ca",
    zendeskUrlLocale: "en-us",
    region: "Les Amériques",
    language: "English",
    country: "Canada",
    googleLocale: "en",
    locale: "en-CA",
  },
  "en-AU": {
    urlPrefix: "au",
    urlPrefixWithSlash: "/au",
    zendeskUrlLocale: "en-us",
    region: "Asie du Pacifique",
    language: "English",
    country: "Australia",
    googleLocale: "en-AU",
    locale: "en-AU",
  },
  "es-ES": {
    urlPrefix: "es",
    urlPrefixWithSlash: "/es",
    zendeskUrlLocale: "en-us",
    region: "Europe",
    language: "Español",
    country: "España",
    googleLocale: "es",
    locale: "es-ES",
  },
  "fr-FR": {
    urlPrefix: "fr",
    urlPrefixWithSlash: "/fr",
    zendeskUrlLocale: "fr",
    region: "Europe",
    language: "Français",
    country: "France",
    googleLocale: "fr",
    locale: "fr-FR",
  },
};

/**
 * This is here to satisfy the design system's expected locale data format (snake case).
 * FIXME: We should fix this in the design system when we work on consolidating the main nav component
 */
const DESIGN_SYSTEM_ACTIVE_LOCALES: Record<Locale, DesignSystemLocaleType> =
  Object.entries(ACTIVE_LOCALES).reduce(
    (acc, [locale, localeData]) => {
      acc[locale as Locale] = {
        url_prefix: localeData.urlPrefix,
        zendesk_url_locale: localeData.zendeskUrlLocale,
        google_locale: localeData.googleLocale,
        translations: localeData.locale,
        ...localeData,
      };
      return acc;
    },
    {} as Record<Locale, DesignSystemLocaleType>,
  );

export { ACTIVE_LOCALES, LOCALES_NAMESPACES, DESIGN_SYSTEM_ACTIVE_LOCALES };
